// extracted by mini-css-extract-plugin
export var Footer = "Footer-module--Footer--+ZePN";
export var acknowledgement = "Footer-module--acknowledgement--40Beg";
export var aniSpin = "Footer-module--ani-spin--ebEJA";
export var column = "Footer-module--column--5O1s3";
export var container = "Footer-module--container--cIk5r";
export var copyright = "Footer-module--copyright--p3W1o";
export var notes = "Footer-module--notes--Z+USu";
export var secondary = "Footer-module--secondary--1W8-k";
export var socialLinks = "Footer-module--socialLinks--TDIkX";